import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp, FiMapPin, FiClock, FiUsers, FiAward, FiBookOpen, FiHome, FiPhone, FiMail, FiInfo, FiArrowRight, FiImage, FiPlay, FiShoppingCart, FiNavigation, FiHeart, FiTrendingUp, FiCoffee, FiDroplet, FiHeart as FiHeartIcon } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

class ExhibitFloor2 extends Component {
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='นิทรรศการชั้น 2' />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.webp" />

                {/* Hero Section */}
                <div className="hero-section" style={{
                    background: 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("/assets/images/singha/floor2/IMG_7982.webp")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    minHeight: '50vh',
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative'
                }}>
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h1 className="hero-title" style={{
                                    color: 'white',
                                    fontSize: '3.5rem',
                                    fontWeight: 'bold',
                                    marginBottom: '1rem',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.7)'
                                }}>
                                    นิทรรศการชั้น 2
                                </h1>
                                <p className="hero-subtitle" style={{
                                    color: 'white',
                                    fontSize: '1.2rem',
                                    opacity: 0.9,
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.7)'
                                }}>
                                    สำรวจวิถีชีวิตและพัฒนาการของชุมชนสิงห์ท่า
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exhibition Overview */}
                <div className="exhibition-overview ptb--50" style={{ backgroundColor: 'white' }}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="exhibition-content">
                                    <h2 className="section-title" style={{
                                        fontSize: '2.5rem',
                                        fontWeight: 'bold',
                                        color: '#242424',
                                        marginBottom: '1.5rem'
                                    }}>
                                        นิทรรศการชั้น 2
                                    </h2>
                                    <p className="description" style={{
                                        color: '#666',
                                        lineHeight: '1.8',
                                        fontSize: '1.5rem',
                                        marginBottom: '2rem'
                                    }}>
                                        ชั้น 2 ของพิพิธภัณฑ์สิงห์ท่า จัดแสดงนิทรรศการที่เล่าเรื่องราววิถีชีวิตและพัฒนาการของชุมชนสิงห์ท่า 
                                        ตั้งแต่ยุคแรกเริ่มจนถึงปัจจุบัน ผ่านการเปลี่ยนแปลงทางสังคม เศรษฐกิจ และวัฒนธรรม
                                    </p>
                                    <div className="exhibition-stats" style={{
                                        display: 'flex',
                                        gap: '2rem',
                                        flexWrap: 'wrap'
                                    }}>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                9
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1.5rem'
                                            }}>
                                                ส่วนจัดแสดง
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                5
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1.5rem'
                                            }}>
                                                ยุคสมัย
                                            </div>
                                        </div>
                                        <div className="stat-item" style={{
                                            textAlign: 'center',
                                            flex: '1',
                                            minWidth: '120px'
                                        }}>
                                            <div className="stat-number" style={{
                                                fontSize: '2.5rem',
                                                fontWeight: 'bold',
                                                color: '#F45354',
                                                marginBottom: '0.5rem'
                                            }}>
                                                100+
                                            </div>
                                            <div className="stat-label" style={{
                                                color: '#666',
                                                fontSize: '1.5rem'
                                            }}>
                                                เรื่องราว
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="exhibition-image" style={{
                                    borderRadius: '20px',
                                    overflow: 'hidden',
                                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                                }}>
                                    <img className="w-100" src="/assets/images/singha/floor2/IMG_7934.webp" alt="นิทรรศการชั้น 2" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Exhibition Sections */}
                <div className="exhibition-sections ptb--50" style={{ backgroundColor: '#f8f9fa' }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 'bold',
                                    color: '#242424',
                                    marginBottom: '3rem',
                                    textAlign: 'center'
                                }}>
                                    ส่วนจัดแสดง
                                </h2>
                            </div>
                        </div>

                        {/* Section 5: ห้วงวิถีชีวิต */}
                        <div className="exhibition-section mb-5">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#F45354',
                                        textAlign: 'center',
                                        marginBottom: '2rem'
                                    }}>
                                        ส่วนจัดแสดงที่ 5: ห้วงวิถีชีวิต
                                    </h2>
                                </div>
                            </div>
                            
                            {/* 5.1 วิถีชีวิต */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiHeart style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                5.1 วิถีชีวิต
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ภาพรวมสังคมในยุคแรกเริ่ม ชาวบ้านดำรงชีวิตในสังคมการเกษตร เลี้ยงสัตว์ ใช้ชีวิตพึ่งพิงอยู่กับแม่น้ำชี แม่น้ำสายหลักที่หล่อเลี้ยงชีวิตคนในชุมชนและสำคัญต่อการพัฒนาความเจริญมาสู่บ้านสิงห์ท่า
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/IMG_7952.webp" alt="วิถีชีวิต" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 5.2 ความเชื่อพื้นถิ่น */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/IMG_7949.webp" alt="ความเชื่อพื้นถิ่น" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiHeart style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                5.2 ความเชื่อพื้นถิ่น
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ชุมชนบ้านสิงห์ท่ามีโครงสร้างที่ผูกพันกับความเชื่อทางด้านศาสนาและสิ่งศักดิ์สิทธิ์ ความเชื่อเหล่านี้มีอิทธิพลต่อวิถีชีวิตที่แสดงออกมาในรูปแบบประเพณีและพิธีกรรมต่าง ๆ
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 5.3 สายน้ำแห่งโอกาส */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiDroplet style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                5.3 สายน้ำแห่งโอกาส
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            แม่น้ำชี แม่น้ำสำคัญที่หล่อเลี้ยงชีวิตคนในชุมชนบ้านสิงห์ท่า ความผูกพันระหว่างคนกับแม่น้ำชีเป็นปัจจัยสำคัญในการพัฒนาชุมชน อีกทั้งเป็นเส้นทางคมนาคมที่นำความเจริญมาสู่บ้านสิงห์ท่าในยุคการค้าในอดีต
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/IMG_7954.webp" alt="สายน้ำแห่งโอกาส" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 6: คนต่างถิ่น */}
                        <div className="exhibition-section mb-5">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#F45354',
                                        textAlign: 'center',
                                        marginBottom: '2rem'
                                    }}>
                                        ส่วนจัดแสดงที่ 6: คนต่างถิ่น
                                    </h2>
                                </div>
                            </div>

                            {/* 6.1 คนต่างถิ่น */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                6.1 คนต่างถิ่น
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            เมื่อคนต่างถิ่นเข้ามาค้าขายและตั้งรกรากในบ้านสิงห์ท่า รูปแบบวิถีชีวิตของชุมชนเกิดความหลากหลายและในที่สุดก็ผสมผสานเป็นรูปแบบของชุมชนในปัจจุบัน
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/6.1.jpg" alt="คนต่างถิ่น" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 6.2 ค้าขายกับโคราช */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/6.2.jpg" alt="ค้าขายกับโคราช" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                6.2 ค้าขายกับโคราช
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            พ่อค้าชาวจีนจากโคราชเดินทางค้าขายทั่วอีสานเพื่อแสวงหาเส้นทางการค้าใหม่ ๆ <br></br>นำไปสู่การตั้งรกรากของพ่อค้าชาวจีนในบ้านสิงห์ท่าและเกิดการเปลี่ยนแปลงทางเศรษฐกิจของชุมชน
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 6.3 พื้นที่ชีวิต */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                6.3 พื้นที่ชีวิต
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            คนต่างถิ่นเข้ามาตั้งรกรากในชุมชนบ้านสิงห์ท่าส่งผลให้เกิดการผสมผสานทางวัฒนธรรมขึ้น เกิดวิถีชีวิตที่หลากหลาย ทั้งด้านครอบครัว ที่อยู่อาศัย และวัฒนธรรมที่หลอมรวมกันอย่างแน่นแฟ้น
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/6.3.jpg" alt="พื้นที่ชีวิต" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 6.4 กิน อยู่ คือ */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/6.4.jpg" alt="กิน อยู่ คือ" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiUsers style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                6.4 กิน อยู่ คือ
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            วัฒนธรรมการกินของชาวสิงห์ท่าสะท้อนภูมิปัญญาการดำรงชีวิตและวิวัฒนาการทางวัฒนธรรมของชุมชนอย่างชัดเจน อาหารแต่ละจานแสดงให้เห็นถึงประวัติศาสตร์และวิถีชีวิตความเป็นอยู่ของชุมชน
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 7: วิถีเมืองการค้า */}
                        <div className="exhibition-section mb-5">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#F45354',
                                        textAlign: 'center',
                                        marginBottom: '2rem'
                                    }}>
                                        ส่วนจัดแสดงที่ 7: วิถีเมืองการค้า
                                    </h2>
                                </div>
                            </div>

                            {/* 7.1 นานาร้านรวง */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiShoppingCart style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                7.1 นานาร้านรวง
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            เมื่อความเป็นอยู่ในชุมชนเริ่มมั่นคงถาวร พ่อค้าชาวจีนได้ใช้พื้นที่สร้างตลาดและย่านการค้า ส่งผลให้ชุมชนเปลี่ยนเป็นศูนย์กลางการค้า มีผู้คนหลั่งไหลเข้ามาทำให้เศรษฐกิจเติบโตและชุมชนขยายตัวขึ้น
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/7.1_1.jpg" alt="นานาร้านรวง" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 7.2 ค้าขายอุบลราชธานี */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/7.2.jpg" alt="ค้าขายอุบลราชธานี" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiShoppingCart style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                7.2 ค้าขายอุบลราชธานี
                                            </h4>
                                        </div>
                                           <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            สยามประเทศเร่งพัฒนาระบบสื่อสารและคมนาคมกับภาคอีสาน การค้าขายระหว่างบ้านสิงห์ท่ากับอุบลราชธานีจึงเติบโตขึ้น ควบคู่กับการมาถึงของรถไฟในหัวเมืองอีสาน
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 8: เศรษฐกิจฟูเฟื่อง */}
                        <div className="exhibition-section mb-5">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#F45354',
                                        textAlign: 'center',
                                        marginBottom: '2rem'
                                    }}>
                                        ส่วนจัดแสดงที่ 8: เศรษฐกิจฟูเฟื่อง
                                    </h2>
                                </div>
                            </div>

                            {/* 8.1 ธุรกิจใหม่ */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiTrendingUp style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                8.1 ธุรกิจใหม่
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            การขยายตัวทางการค้าตามความต้องการของผู้บริโภคส่งผลให้เกิดธุรกิจใหม่ ๆ ภายในชุมชนบ้านสิงห์ท่า ร้านค้าทันสมัยและสถานบันเทิงได้ถือกำเนิดเพื่อดึงดูดผู้คนจากภายนอกเข้ามาในชุมชนมากขึ้น
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/8.1.jpg" alt="ธุรกิจใหม่" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 8.2 สินค้าสมัยนิยม */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/8.2.jpg" alt="สินค้าสมัยนิยม" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiTrendingUp style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                8.2 สินค้าสมัยนิยม
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ความต้องการของผู้บริโภคขยายตัวตามช่องทางสื่อสารที่ทันสมัยมีส่วนสำคัญในการเปลี่ยนแปลงวิถีชีวิตและเศรษฐกิจของชุมชนบ้านสิงห์ท่า ส่งผลเกิดความหลากหลายในสินค้าและบริการที่มีอยู่ในพื้นที่
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* 8.3 ไลฟ์สไตล์แห่งยุค */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiTrendingUp style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                8.3 ไลฟ์สไตล์แห่งยุค
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ยุคที่บ้านสิงห์ท่าเจริญรุ่งเรืองเป็นช่วงเวลาแห่งการเปลี่ยนแปลงที่สำคัญ การใช้ชีวิตของคนในชุมชนเป็นอย่างไรท่ามกลางยุคสมัยของการพัฒนาพื้นที่ให้ทันต่อโลก
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/8.3.jpg" alt="ไลฟ์สไตล์แห่งยุค" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Section 9: เล่าเรื่องเมืองเก่า */}
                        <div className="exhibition-section">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <h2 style={{
                                        fontSize: '2rem',
                                        fontWeight: 'bold',
                                        color: '#F45354',
                                        textAlign: 'center',
                                        marginBottom: '2rem'
                                    }}>
                                        ส่วนจัดแสดงที่ 9: เล่าเรื่องเมืองเก่า
                                    </h2>
                                </div>
                            </div>

                            {/* 9.1 กาลเวลาผันผ่าน */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiBookOpen style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                9.1 กาลเวลาผันผ่าน
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            การขยายตัวของชุมชนบ้านสิงห์ท่าทำให้ผู้คนย้ายถิ่นฐานไปสร้างบ้านเรือนรอบนอก พ่อค้าย้ายออกไปสู่ฝั่งเมืองใหม่ ส่งผลให้ตลาดหลักเมืองลดบทบาทศูนย์กลางการค้าลงเหลือเพียงร่องรอยความรุ่งเรืองในอดีต
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/9.1.jpg" alt="กาลเวลาผันผ่าน" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                            </div>

                            {/* 9.2 ห้วงเวลาปัจจุบัน */}
                            <div className="row mb-4">
                                <div className="col-lg-6 col-md-12 mb-4">
                                    <div className="exhibition-image" style={{
                                        borderRadius: '20px',
                                        overflow: 'hidden',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        minHeight: '200px'
                                    }}>
                                        <img className="w-100" src="/assets/images/singha/floor2/9.2.jpg" alt="ห้วงเวลาปัจจุบัน" style={{ objectFit: 'cover', height: '100%' }} />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="exhibition-card" style={{
                                        backgroundColor: 'white',
                                        padding: '2rem',
                                        borderRadius: '20px',
                                        boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
                                        height: '100%',
                                        transition: 'transform 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-5px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                    }}>
                                        <div className="section-header" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '1rem'
                                        }}>
                                            <div className="section-icon" style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '50px',
                                                height: '50px',
                                                backgroundColor: '#F45354',
                                                borderRadius: '50%',
                                                marginRight: '1rem'
                                            }}>
                                                <FiBookOpen style={{ color: 'white', fontSize: '1.2rem' }} />
                                            </div>
                                            <h4 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 'bold',
                                                color: '#242424',
                                                margin: 0
                                            }}>
                                                9.2 ห้วงเวลาปัจจุบัน
                                            </h4>
                                        </div>
                                        <p style={{
                                            color: '#666',
                                            lineHeight: '1.6',
                                            fontSize: '1.5rem',
                                            margin: 0
                                        }}>
                                            ชุมชนบ้านสิงห์ท่าในปัจจุบันยังคงมีร่องรอยความเจริญรุ่งเรืองในอดีตให้เห็นทั้งด้านสถาปัตยกรรมและวิถีชีวิตของผู้คน แม้ว่าความคึกคักทางการค้าจะลดลงไปแต่บรรยากาศของชุมชนที่เต็มไปด้วยเรื่องราวทางประวัติศาสตร์ยังคงอยู่
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                <Footer />
            </React.Fragment>
        )
    }
}
export default ExhibitFloor2;







